import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import type { Game } from '@/types'
import { GameCover } from '@/components/ui/GameCover'
import { StarRating } from '@/components/ui/StarRating'

interface RatePromptModalProps {
  game: Game
  onSubmit: (rating: number) => void
  onSkip: () => void
}

export function RatePromptModal({ game, onSubmit, onSkip }: RatePromptModalProps) {
  const [rating, setRating] = useState(0)

  useEffect(() => {
    function handleKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onSkip()
    }
    document.addEventListener('keydown', handleKey)
    return () => document.removeEventListener('keydown', handleKey)
  }, [onSkip])

  return createPortal(
    <div className="cg-modal-backdrop" onClick={onSkip}>
      <div
        className="cg-modal"
        style={{ width: 420 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="cg-modal-header">
          <h2>Rate {game.title}?</h2>
        </div>

        <div style={{ padding: 18, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
          <GameCover game={game} size="md" />
          <p style={{ margin: 0, fontSize: 13, color: 'var(--fg-2)', textAlign: 'center' }}>
            Ratings help make recommendations more accurate.
          </p>
          <StarRating
            value={rating}
            onChange={setRating}
            size={28}
            ariaLabel={`Rate ${game.title}`}
          />
        </div>

        <div className="cg-modal-footer">
          <button className="cg-btn ghost" onClick={onSkip}>Skip</button>
          <button
            className="cg-btn primary"
            disabled={rating === 0}
            onClick={() => onSubmit(rating)}
          >
            Save rating
          </button>
        </div>
      </div>
    </div>,
    document.body,
  )
}
